module.exports = __webpack_public_path__ + "static/media/stofferingen-37.75845fcb.jpg";